const e=()=>{const e=window.location.href,{referrer:r}=document;return{page_url:e,referer:r,ts:Math.floor(Date.now()/1e3),tz:(new Date).getTimezoneOffset()}};export{e as getCustomParamsCH2};
